import React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle, Dialog, DialogContentText } from '@mui/material';

export interface ConfirmContinueDialogProps {
    onConfirm: () => void;
    onCancel?: () => void;
    message: string;
    title: string;
}

export function ConfirmContinueDialog(props: ConfirmContinueDialogProps) {
    function handleCancel() {
        if (props.onCancel) {
            props.onCancel();
        }
    }

    async function handleConfirm() {
        props.onConfirm();
    }

    return (
        <Dialog open={true} fullWidth>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleConfirm} color="error">
                    Continue
                </Button>
                <Button onClick={handleCancel} color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>)
}